/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_ListingsInputs */

const en_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Listings`)
};

const es_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios activos`)
};

const fr_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces actives`)
};

const de_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Inserate`)
};

const ja_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブな出品`)
};

const zh_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在售商品数`)
};

const ar_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعلانات النشطة`)
};

const id_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Aktif`)
};

const it_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annunci Attivi`)
};

const ru_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активные объявления`)
};

const pt_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios Ativos`)
};

const ko_active_listings = /** @type {(inputs: Active_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성 상품`)
};

/**
* | output |
* | --- |
* | "Active Listings" |
*
* @param {Active_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const active_listings = /** @type {((inputs?: Active_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_active_listings(inputs)
	if (locale === "es") return es_active_listings(inputs)
	if (locale === "fr") return fr_active_listings(inputs)
	if (locale === "de") return de_active_listings(inputs)
	if (locale === "ja") return ja_active_listings(inputs)
	if (locale === "zh") return zh_active_listings(inputs)
	if (locale === "ar") return ar_active_listings(inputs)
	if (locale === "id") return id_active_listings(inputs)
	if (locale === "it") return it_active_listings(inputs)
	if (locale === "ru") return ru_active_listings(inputs)
	if (locale === "pt") return pt_active_listings(inputs)
	return ko_active_listings(inputs)
});